var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3640",
    "data-name": "Rectangle 3640",
    width: 124,
    height: 124,
    transform: "translate(898 478)",
    fill: "#ed8b00",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_661",
    "data-name": "Mask Group 661",
    transform: "translate(-898 -478)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BPD-icon2-red-03",
    transform: "translate(916.314 478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M75.458,56.135H83.69a3.679,3.679,0,0,0,3.679-3.679V22.224a3.679,3.679,0,0,0-3.679-3.679H59.59V15.9A15.911,15.911,0,0,0,53.416,3.348L24.794,105.914h2.986V108.1A15.921,15.921,0,0,0,43.722,124H44a15.921,15.921,0,0,0,15.9-15.9v-2.186H83.69a3.668,3.668,0,0,0,3.679-3.668V71.821a3.668,3.668,0,0,0-3.679-3.668H75.458a6.014,6.014,0,1,1,0-12.018",
    fill: "#00c9db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M43.722,0A15.921,15.921,0,0,0,27.779,15.9v2.645H3.668A3.679,3.679,0,0,0,0,22.224V52.456a3.668,3.668,0,0,0,3.668,3.679h8.243a6.014,6.014,0,0,1,6.014,6v.181a6.025,6.025,0,0,1-6.014,6.014H3.668A3.668,3.668,0,0,0,0,72v30.243a3.668,3.668,0,0,0,3.668,3.668H24.794L53.416,3.359A15.783,15.783,0,0,0,43.722,0",
    fill: "#359ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M51.24,60.411a3.668,3.668,0,0,1-3.668-3.668V51.624c-.224-5.567-2.5-5.567-4.148-5.567s-3.967,0-4.17,5.588v5.1a3.668,3.668,0,1,1-7.337,0V51.411c.139-3.85,1.525-12.711,11.506-12.711S54.77,47.55,54.908,51.357v5.332a3.668,3.668,0,0,1-3.668,3.668",
    fill: "#9a9188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M50.526,85.311H36.567c-4.479,0-8.115-3.988-8.115-8.883V61.9c0-4.895,3.636-8.872,8.115-8.872H50.526c4.468,0,8.1,3.978,8.1,8.872V76.4c0,4.895-3.636,8.883-8.1,8.883",
    fill: "#f6911e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M48.414,67.439a4.873,4.873,0,1,0-7.625,4.01v1.685a2.751,2.751,0,0,0,5.5,0V71.448a4.852,4.852,0,0,0,2.133-4.01",
    fill: "#69564d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/not-found-icon.eca842de4040d0f42848460f311324f4.svg";
export { ForwardRef as ReactComponent };